<template>
    <v-footer>
        <v-container class="footer">
            <div class="footer__top">
                <div class="footer__logo">
                    <router-link :to="mainPageUrl">
                        <img :src="mobileLogotypePath" :alt="mainPageAlt" v-if="isMobile"/>
                        <img :src="logotypePath" :alt="mainPageAlt" v-else/>
                    </router-link>
                </div>

                <single-page-part :pagePart="warningPart"/>

                <language-switcher :id="`LS-FOO`"/>
            </div>

            <div class="footer__content">
                <div>
                    <single-page-part :pagePart="smallMenuPart"/>
                </div>
                <div>
                    <single-page-part :pagePart="middleMenuPart"/>
                </div>
                <div>
                    <single-page-part :pagePart="bigMenuPart"/>
                </div>

                <div>
                    <single-page-part :pagePart="helpPart"/>

                    <v-form ref="subscribeNewsletterForm" v-model="subscribeNewsletterForm" lazy-validation>
                        <div class="footer__subscribe">
                            <p>{{ $t('front.footer.titles.subscribe_newsletter') }}</p>

                            <div class="subscribe">
                                <v-text-field type="email" class="email" v-model="newsletterSubscriptionEmail"
                                              :rules="newsletterSubscriptionEmailRules"
                                              :placeholder="$t('front.footer.placeholder.email')"
                                              hide-details="auto" required autocomplete="off"/>

                                <v-btn class="btn btn-primary" @click="subscribeNewsletter">
                                    {{ $t('front.footer.button.subscribe') }}
                                </v-btn>
                            </div>

                            <v-checkbox v-model="regulationsCheck" :rules="regulationsCheckRules" hide-details="auto"
                                        :label="$t('front.footer.titles.years_old')">
                            </v-checkbox>
                        </div>
                    </v-form>
                </div>
            </div>

            <div class="footer__partners">
                <single-page-part :pagePart="partnersPart"/>
            </div>

            <div class="footer__copyright">
                <single-page-part :pagePart="copyrightPart"/>
            </div>
        </v-container>
    </v-footer>
</template>

<script>
import casinoLicense from "../../../../../src/mixins/casinoLicense";
import apiData from "../../../../../src/mixins/apiData";
import toaster from "../../../../../src/mixins/toaster";
import {appName, brandName} from "../../../../../config/app";
import {VCheckbox} from 'vuetifyComponents/VCheckbox';
import {subscribeGuestToNewsLetters} from "../../../../../src/api";
import {setGuestToken} from "../../../../../src/util/user/setGuestData";

export default {
    name: "TheFooter",

    components: {VCheckbox},

    mixins: [casinoLicense, apiData, toaster],

    data: function () {
        return {
            isMobile: false,
            subscribeNewsletterForm: true,
            regulationsCheck: false,
            regulationsCheckRules: [
                v => !!v || this.$t('front.validation.conditions.agree'),
            ],
            newsletterSubscriptionEmail: '',
            newsletterSubscriptionEmailRules: [
                v => !!v || this.$t('front.validation.email.required'),
                v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || this.$t('front.validation.email.not_valid'),
            ],
        };
    },

    mounted() {
        this.defineScreenWidth();
        window.addEventListener('resize', this.defineScreenWidth);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.defineScreenWidth);
    },

    computed: {
        warningPart() {
            return this.$store.getters.getLayoutPagePart('footerWarning');
        },

        bigMenuPart() {
            return this.$store.getters.getLayoutPagePart('footerBigMenu');
        },

        smallMenuPart() {
            return this.$store.getters.getLayoutPagePart('footerSmallMenu');
        },

        middleMenuPart() {
            return this.$store.getters.getLayoutPagePart('footerMiddleMenu');
        },

        partnersPart() {
            return this.$store.getters.getLayoutPagePart('footerPartners');
        },

        helpPart() {
            return this.$store.getters.getLayoutPagePart('footerHelp');
        },

        footerProviders() {
            return this.$store.getters.getLayoutPagePart('footerProviders');
        },

        copyrightPart() {
            return this.$store.getters.getLayoutPagePart('footerCopyright');
        },

        mainPageUrl() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix() || '/';
            return `${languageUrlPrefix}`;
        },

        mainPageAlt() {
            return appName;
        },

        logotypePath() {
            return `/public/${brandName}/logotype/logo-footer.svg`;
        },

        mobileLogotypePath() {
            return `/public/${brandName}/logotype/logo-footer-mob.svg`;
        },
    },

    methods: {
        defineScreenWidth() {
            this.isMobile = window.innerWidth <= 800;
        },

        subscribeNewsletter() {
            if (!this.$refs.subscribeNewsletterForm.validate()) {
                return;
            }

            subscribeGuestToNewsLetters(this.createApiData({
                'newsletterSubscriptionEmail': this.newsletterSubscriptionEmail,
            }))
                .then(({customer}) => {
                    customer && setGuestToken(customer.guest_token, this.$store, this.$cookies);
                    this.makeSuccessToast(this.$t('front.footer.titles.newsletter_subscribed'));
                })
                .catch(() => this.makeErrorToast(this.$t('front.api.service_unavailable')));
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/layout/TheFooter"
</style>